import { render, staticRenderFns } from "./vz-modal.vue?vue&type=template&id=1a255612&scoped=true"
import script from "./vz-modal.vue?vue&type=script&lang=js"
export * from "./vz-modal.vue?vue&type=script&lang=js"
import style0 from "./vz-modal.vue?vue&type=style&index=0&id=1a255612&prod&theme=dark-theater&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a255612",
  null
  
)

export default component.exports